import React from 'react'
import { Badge, Tag } from 'antd'

export const getStatusBadge = (status) => {
  let statusProps
  switch (status) {
    case 'Completed':
      statusProps = { status: 'success', text: 'Completed' }
      break
    case 'In Progress':
      statusProps = { status: 'processing', text: 'In Progress' }
      break
    case 'Delayed':
      statusProps = { status: 'warning', text: 'Delayed' }
      break
    case 'Cancelled':
      statusProps = { status: 'error', text: 'Cancelled' }
      break
    default:
      statusProps = { status: 'default', text: status }
  }
  return <Badge {...statusProps} />
}

export const getCategoryTag = (category) => {
  let color
  switch (category) {
    case 'Surgery':
      color = 'blue'
      break
    case 'Maintenance':
      color = 'orange'
      break
    case 'Cardiology Procedure':
      color = 'purple'
      break
    default:
      color = 'green'
  }
  return <Tag color={color}>{category}</Tag>
}

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export const formatTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export const getDuration = (startDateTime, endDateTime) => {
  if (!startDateTime || !endDateTime) return '-'

  const start = new Date(startDateTime)
  const end = new Date(endDateTime)
  const diffMinutes = Math.round((end - start) / (1000 * 60))

  if (diffMinutes < 60) {
    return `${diffMinutes} min`
  } else {
    const hours = Math.floor(diffMinutes / 60)
    const minutes = diffMinutes % 60
    return `${hours}h ${minutes > 0 ? `${minutes}m` : ''}`
  }
}

export const getTimelineItemColor = (event) => {
  if (event.eventCategory === 'Surgery') return 'blue'
  if (event.eventCategory === 'Maintenance') return 'orange'
  if (event.eventCategory === 'Cardiology Procedure') return 'purple'
  return 'green'
}

export const getEventTypeTag = (eventType) => {
  const eventTypeColors = {
    Procedure: 'magenta',
    Cleaning: 'cyan',
    'Equipment Check': 'purple',
    Maintenance: 'gold',
    Surgery: 'red',
    'Patient Prep': 'green',
    'Post-Op Recovery': 'geekblue',
    'Anesthesia Prep': 'volcano',
    'Emergency Procedure': 'red',
    Sterilization: 'blue'
  }

  // Use the color mapping if available, or default to blue
  const color = eventTypeColors[eventType] || 'blue'
  return <Tag color={color}>{eventType}</Tag>
}
